import Vue from 'vue'

const UserMemory = 'user_memory'

export function getLs(keys) {
  const key = Vue.ls.get('sid') + '/' + Vue.ls.get('account')
  const memoryData = Vue.ls.get(UserMemory)
  if (!key || !memoryData || memoryData[key] === undefined) {
    return undefined
  }
  let value = memoryData[key]
  const keyList = keys.split('.')
  for (let i = 0; i < keyList.length; i++) {
    value = value[keyList[i]]
    if (value === undefined) {
      return undefined
    }
  }
  return value
}

export function setLs(keys, value) {
  const key = Vue.ls.get('sid') + '/' + Vue.ls.get('account')
  if (!key) return
  let memoryData = Vue.ls.get(UserMemory)
  if (!memoryData) memoryData = {}
  if (memoryData[key] === undefined) memoryData[key] = {}
  const keyList = keys.split('.')
  setObjectAttr(memoryData[key], keyList, value)
  Vue.ls.set(UserMemory, memoryData)
}

function setObjectAttr(object, path, value) {
  const type = typeof (path)
  if (type === 'object' && type.length !== 0) {
    let current = object
    for (let i = 0; i < path.length; i++) {
      if (i !== path.length - 1) {
        if (current[path[i]] === undefined) {
          current[path[i]] = {}
        }
        current = current[path[i]]
      } else {
        current[path[i]] = value
      }
    }
  }
}

export function contrastLs(value, options, type) {
  if (type === 'select') {
    if (options.find(option => option.id === value)) {
      return value
    }
    return ''
  } else if (type === 'select-plus') {
    if (Array.isArray(value)) {
      return value.filter(v => {
        return options.find(item => item.id === v)
      })
    }
    return []
  } else if (type === 'select-tree-plus' || type === 'cascader') {
    if (Array.isArray(value)) {
      return value.filter(v => {
        return isTreeOptionsValue(v, options)
      })
    }
    return []
  }
  return value
}

function isTreeOptionsValue(value, options) {
  for (let i = 0; i < options.length; i++) {
    if (options[i].id === value) {
      return true
    } else if (options[i]?.children?.length) {
      const res = isTreeOptionsValue(value, options[i]?.children)
      if (res) return true
    }
  }
  return false
}
